import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  MANAGE: {
    id: 'Manage.manage',
    defaultMessage: 'Manage',
    description: '[Type: Label][Vis.: low] - Manage link in main navigation',
  },
});

const Manage = () => {
  const url = createURL('/apps/my-apps', { ut_source: 'header' });
  const title = t(COPY.MANAGE);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.MANAGE} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.MANAGE} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default Manage;
export { Manage };
